import { axios } from '@/plugins/axios';

export class NotificationService {
  private endpoint: string;

  constructor() {
    this.endpoint = 'v1/notifications/';
  }

  async message(payload: any) {
    return axios
      .post(`${this.endpoint}messages/`, {
        title: payload.title,
        event: payload.event,
        message: payload.message,
        data: payload.data ?? '{"type":"1", "subtype":"1"}',
        scheduled_time: payload.scheduled_time
      })
      .then(response => {
        console.log('Notification: ', { response });
        return response;
      });
  }
}
